import apiCore from '../../utils/api-core';

export function getAllApps(path) {
	let url = '/api/v1/apps/user';
	if (path) {
		url += `?path=${path}`;
	}
	return apiCore.get(url);
}

export function setAppAsDefault(data) {
	return apiCore.post('/api/v1/apps/set-default', data);
}

export function checkUserGroupDefault(group) {
	return apiCore.get(`/api/v1/apps/check-default/${group}`);
}